/* 全站唯一的手机端图片预览。
   只有带 data-pq-preview="图片地址" 的元素会打开它。桌面不拦截点击。 */
(() => {
  const preview = document.querySelector('[data-pq-preview-dialog]');
  const previewStage = preview && preview.querySelector('[data-pq-preview-stage]');
  const previewImage = preview && preview.querySelector('[data-pq-preview-image]');
  if (!preview || !previewStage || !previewImage) return;

  const mediaQuery = window.matchMedia('(max-width: 749px)');
  const previewPointers = new Map();
  let previewScale = 1;
  let previewX = 0;
  let previewY = 0;
  let previewPinch = null;
  let previewPan = null;
  let previewGestured = false;
  let previewFrame = 0;
  let previewStageWidth = 0;
  let previewStageHeight = 0;
  let previewStageLeft = 0;
  let previewStageTop = 0;
  let previewRequest = 0;
  let closeGeneration = 0;

  const largerPreviewSrc = (src) => {
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', '2000');
      return url.toString();
    } catch (error) {
      return src;
    }
  };

  const applyPreviewTransform = () => {
    previewImage.style.transform =
      previewScale === 1 && previewX === 0 && previewY === 0
        ? ''
        : `translate(${previewX}px, ${previewY}px) scale(${previewScale})`;
  };

  const cancelPreviewFrame = () => {
    if (!previewFrame) return;
    cancelAnimationFrame(previewFrame);
    previewFrame = 0;
  };

  const resetPreviewTransform = () => {
    cancelPreviewFrame();
    previewScale = 1;
    previewX = 0;
    previewY = 0;
    previewPinch = null;
    previewPan = null;
    previewGestured = false;
    previewPointers.clear();
    previewImage.style.transform = '';
    previewImage.style.willChange = '';
  };

  const rememberPreviewStageSize = () => {
    const rect = previewStage.getBoundingClientRect();
    previewStageLeft = rect.left;
    previewStageTop = rect.top;
    previewStageWidth = rect.width;
    previewStageHeight = rect.height;
  };

  const previewStageCenter = () => ({
    x: previewStageLeft + previewStageWidth / 2,
    y: previewStageTop + previewStageHeight / 2,
  });

  const clampPreviewPan = () => {
    if (previewScale <= 1) {
      previewX = 0;
      previewY = 0;
      return;
    }
    const maxX = (previewStageWidth * (previewScale - 1)) / 2;
    const maxY = (previewStageHeight * (previewScale - 1)) / 2;
    previewX = Math.min(maxX, Math.max(-maxX, previewX));
    previewY = Math.min(maxY, Math.max(-maxY, previewY));
  };

  const schedulePreviewTransform = () => {
    if (previewFrame) return;
    previewFrame = requestAnimationFrame(() => {
      previewFrame = 0;
      clampPreviewPan();
      applyPreviewTransform();
    });
  };

  const pointerDistance = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);

  const restoreFocus = () => {
    const sheet = document.querySelector('[data-pq-mobile-buy-sheet].is-open');
    const panel = sheet && sheet.querySelector('.pq-mobile-buy-sheet__panel');
    if (panel && typeof trapFocus === 'function') {
      trapFocus(panel, panel.querySelector('.pq-mobile-buy-sheet__close') || panel);
      return;
    }
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
  };

  const imagePath = (src) => {
    try {
      return new URL(src, window.location.origin).pathname;
    } catch (error) {
      return src || '';
    }
  };

  const finishClose = (generation) => {
    if (generation !== closeGeneration || preview.hidden) return;
    preview.hidden = true;
    preview.classList.remove('is-closing');
    resetPreviewTransform();
    previewImage.removeAttribute('src');
    restoreFocus();
  };

  const closePreview = () => {
    if (preview.hidden || preview.classList.contains('is-closing')) return;
    previewRequest += 1;
    closeGeneration += 1;
    const generation = closeGeneration;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      finishClose(generation);
      return;
    }
    preview.classList.add('is-closing');
    const onEnd = (event) => {
      if (event.target !== preview || event.propertyName !== 'opacity') return;
      preview.removeEventListener('transitionend', onEnd);
      finishClose(generation);
    };
    preview.addEventListener('transitionend', onEnd);
    window.setTimeout(() => {
      preview.removeEventListener('transitionend', onEnd);
      finishClose(generation);
    }, 320);
  };

  const warmPreview = (src) => {
    if (!mediaQuery.matches || !src) return;
    const sharp = largerPreviewSrc(src);
    if (!sharp) return;
    const loader = new Image();
    loader.decoding = 'async';
    loader.src = sharp;
  };

  const openPreview = (src, hint) => {
    if (!mediaQuery.matches || !src) return false;
    closeGeneration += 1;
    preview.classList.remove('is-closing');
    resetPreviewTransform();
    const shown = hint && (hint.currentSrc || hint.getAttribute('src'));
    const first = shown && imagePath(shown) === imagePath(src) ? shown : src;
    const sharp = largerPreviewSrc(src);
    const alreadySharp = Boolean(hint && hint.complete && hint.naturalWidth >= 1200);
    previewRequest += 1;
    const request = previewRequest;
    previewImage.decoding = 'auto';
    previewImage.src = first;
    preview.hidden = false;
    if (!alreadySharp && sharp && sharp !== first) {
      const loader = new Image();
      loader.decoding = 'async';
      loader.onload = () => {
        if (request !== previewRequest || preview.hidden) return;
        previewImage.src = loader.src;
      };
      loader.src = sharp;
    }
    if (typeof trapFocus === 'function') {
      trapFocus(preview, preview.querySelector('[data-pq-preview-close]') || preview);
    }
    return true;
  };

  const pointFromEvent = (event) => ({ x: event.clientX, y: event.clientY });

  previewStage.addEventListener('pointerdown', (event) => {
    if (event.button != null && event.button !== 0) return;
    if (previewPointers.size === 0) rememberPreviewStageSize();
    previewImage.style.willChange = 'transform';
    previewStage.setPointerCapture(event.pointerId);
    previewPointers.set(event.pointerId, pointFromEvent(event));
    previewGestured = false;
    if (previewPointers.size >= 2) {
      const points = Array.from(previewPointers.values());
      const mid = {
        x: (points[0].x + points[1].x) / 2,
        y: (points[0].y + points[1].y) / 2,
      };
      const center = previewStageCenter();
      const safeScale = previewScale || 1;
      previewPinch = {
        distance: pointerDistance(points[0], points[1]),
        scale: previewScale,
        originX: (mid.x - center.x - previewX) / safeScale,
        originY: (mid.y - center.y - previewY) / safeScale,
      };
      previewPan = null;
    } else if (previewScale > 1) {
      previewPan = { x: event.clientX, y: event.clientY, originX: previewX, originY: previewY };
    }
  });

  previewStage.addEventListener(
    'pointermove',
    (event) => {
      if (!previewPointers.has(event.pointerId)) return;
      previewPointers.set(event.pointerId, pointFromEvent(event));
      if (previewPointers.size >= 2 && previewPinch) {
        const points = Array.from(previewPointers.values());
        const distance = pointerDistance(points[0], points[1]);
        const mid = {
          x: (points[0].x + points[1].x) / 2,
          y: (points[0].y + points[1].y) / 2,
        };
        const center = previewStageCenter();
        let nextScale = previewScale;
        if (previewPinch.distance > 0) {
          nextScale = Math.min(4, Math.max(1, previewPinch.scale * (distance / previewPinch.distance)));
        }
        if (nextScale <= 1) {
          previewScale = 1;
          previewX = 0;
          previewY = 0;
        } else {
          previewScale = nextScale;
          previewX = mid.x - center.x - previewPinch.originX * nextScale;
          previewY = mid.y - center.y - previewPinch.originY * nextScale;
        }
        previewGestured = true;
        schedulePreviewTransform();
        return;
      }
      if (previewPan && previewScale > 1) {
        previewX = previewPan.originX + (event.clientX - previewPan.x);
        previewY = previewPan.originY + (event.clientY - previewPan.y);
        if (Math.hypot(event.clientX - previewPan.x, event.clientY - previewPan.y) > 8) previewGestured = true;
        schedulePreviewTransform();
      }
    },
    { passive: true }
  );

  const endPreviewPointer = (event) => {
    previewPointers.delete(event.pointerId);
    if (previewPointers.size < 2) previewPinch = null;
    if (previewPointers.size === 0) {
      previewPan = null;
      previewImage.style.willChange = '';
    }
    if (previewScale <= 1) {
      previewScale = 1;
      previewX = 0;
      previewY = 0;
      cancelPreviewFrame();
      applyPreviewTransform();
    }
  };

  previewStage.addEventListener('pointerup', endPreviewPointer);
  previewStage.addEventListener('pointercancel', endPreviewPointer);

  const previewClose = preview.querySelector('[data-pq-preview-close]');
  if (previewClose) {
    previewClose.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closePreview();
    });
  }

  const previewImageHit = (event) => {
    if (event.target !== previewImage) return false;
    const rect = previewImage.getBoundingClientRect();
    const naturalWidth = previewImage.naturalWidth;
    const naturalHeight = previewImage.naturalHeight;
    if (!naturalWidth || !naturalHeight || !rect.width || !rect.height) return true;
    const fitted = Math.min(rect.width / naturalWidth, rect.height / naturalHeight);
    const drawnWidth = naturalWidth * fitted;
    const drawnHeight = naturalHeight * fitted;
    const left = rect.left + (rect.width - drawnWidth) / 2;
    const top = rect.top + (rect.height - drawnHeight) / 2;
    return (
      event.clientX >= left &&
      event.clientX <= left + drawnWidth &&
      event.clientY >= top &&
      event.clientY <= top + drawnHeight
    );
  };

  preview.addEventListener('click', (event) => {
    if (event.target.closest('[data-pq-preview-close]')) {
      closePreview();
      return;
    }
    if (previewGestured) {
      previewGestured = false;
      event.preventDefault();
      return;
    }
    if (previewScale <= 1 && !previewImageHit(event)) {
      closePreview();
    }
  });

  document.addEventListener(
    'click',
    (event) => {
      if (!mediaQuery.matches) return;
      const trigger = event.target.closest('[data-pq-preview]');
      if (!trigger) return;
      const src = trigger.getAttribute('data-pq-preview');
      if (!src) return;
      event.preventDefault();
      event.stopPropagation();
      const hint = trigger.parentElement?.querySelector('img') || trigger.querySelector('img');
      openPreview(src, hint);
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (!mediaQuery.matches) return;
      const trigger = event.target.closest('[data-pq-preview]');
      if (!trigger) return;
      warmPreview(trigger.getAttribute('data-pq-preview'));
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Escape' || preview.hidden) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      closePreview();
    },
    true
  );

  const onViewportChange = () => {
    if (!mediaQuery.matches) closePreview();
  };

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', onViewportChange);
  } else {
    mediaQuery.addListener(onViewportChange);
  }

  window.PqMobilePreview = {
    open: openPreview,
    close: closePreview,
    warm: warmPreview,
  };
})();
